import { render, staticRenderFns } from "./FlowListItem.vue?vue&type=template&id=6c2d881e&scoped=true&"
import script from "./FlowListItem.vue?vue&type=script&lang=js&"
export * from "./FlowListItem.vue?vue&type=script&lang=js&"
import style0 from "./FlowListItem.vue?vue&type=style&index=0&id=6c2d881e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2d881e",
  null
  
)

export default component.exports